import { render, staticRenderFns } from "./MonitorCard.vue?vue&type=template&id=9550b222&scoped=true&"
import script from "./MonitorCard.vue?vue&type=script&lang=js&"
export * from "./MonitorCard.vue?vue&type=script&lang=js&"
import style0 from "./MonitorCard.vue?vue&type=style&index=0&id=9550b222&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9550b222",
  null
  
)

export default component.exports